"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
exports.default = (function (props) { return (react_1.default.createElement("div", { className: "input flex flex-row" },
    react_1.default.createElement("label", null,
        props.altLabel || lodash_1.default.startCase(props.name.replace(/-/g, " ")),
        ":"),
    react_1.default.createElement("div", { className: "radios flex flex-row" }, props.options.map(function (option, index) { return (react_1.default.createElement("div", { className: "radio flex flex-row", key: "ra_" + props.name + "_" + index },
        react_1.default.createElement("input", { type: "radio", onChange: props.onChange, checked: option.value.toString() === props.value.toString(), name: props.name, value: option.value, id: "ra_" + props.name + "_" + option.label.replace(/ /g, "_") }),
        react_1.default.createElement("label", { htmlFor: "ra_" + props.name + "_" + option.label.replace(/ /g, "_") }, option.label))); })))); });
